import { ref } from 'vue';
import { defineStore } from 'pinia';
import { IModal, IModalPayload } from "@/types";

export const useModalStore = defineStore('modalStore', () => {
  const modalToShow = ref<IModal["modalToShow"]>(null);
  const modalPayload = ref<IModalPayload>({});

  const activeTab = ref<string>('0');

  const showModal = (modalIndex: string) => {
    modalToShow.value = modalIndex;
  };

  const hideModal = () => {
    modalToShow.value = null;
  };

  const openModal = (modalIndex: string, payload?: any) => {
    showModal(modalIndex);

    if (payload) {
      modalPayload.value = payload;
    }

  };

  const closeModal = () => {
    hideModal();
    modalPayload.value = {}
  };

  const chooseTab = (tab: string) => {
    activeTab.value = tab;
  };

  const isModalVisible = (modalIndex: string): boolean => {
    return modalToShow.value === modalIndex;
  };

  return {
    modalToShow,
    showModal,
    hideModal,
    openModal,
    closeModal,
    isModalVisible,
    modalPayload,
    chooseTab,
    activeTab
  };
});
